import React from 'react';
// import loadable from "@loadable/component";

import { schemaFunction } from "../schemas/task-dyce.schema";
import moment from 'moment';

export const isInMobileView = () => {
    return window.nsWebViewBridge && window.nsWebViewBridge.emit &&
        typeof window.nsWebViewBridge.emit === 'function';
}

export const getOptions = (list, value, text) => {
    // make a filter for list items and remove duplicates
    if (list.length === 1)
        return <option value={list[0][value]}>{list[0][text]}</option>

    return (
        <React.Fragment>
            <option value="">---</option>
            {list.map(item => <option value={item[value]}>{item[text]}</option>)}
        </React.Fragment>
    )
}


export const transformSchema = (schema = {}, type = 'G') => {
    return {
        ...schema,
        properties: {
            ...schema.properties,
            type: {
                ...schema.properties.type,
                anyOf: JSON.parse(JSON.stringify(schema.properties.type.anyOf[type]))
            }
        }
    }
}

export const getSchema = (schema = {}, meterPointsData = []) => {
    if (!meterPointsData || !Array.isArray(meterPointsData) || meterPointsData.length < 1 || !meterPointsData[0].purpose) {
        return {}
    }
    if (meterPointsData[0].purpose === 'Gas') {
        return transformSchema(schema, 'G') //transformSchema(schemaFunction("filter-hidden-first-one-element"), 'E')
    }
    if (meterPointsData[0].purpose === 'Electricity' || meterPointsData[0].purpose === 'Power') {
        return transformSchema(schema, 'E')
    }
    return {}
}

export const getSchemaCreteQuery = (schema = {}, meterPointsData = []) => {
    if (!meterPointsData || !Array.isArray(meterPointsData) || meterPointsData.length < 1 || !meterPointsData[0].purpose) {
        return {}
    }
    if (meterPointsData[0].purpose === 'Gas') {
        return transformSchema(schemaFunction("filter-hidden-first-one-element"), 'G')
    }
    if (meterPointsData[0].purpose === 'Electricity' || meterPointsData[0].purpose === 'Power') {
        return transformSchema(schemaFunction("filter-hidden-first-one-element"), 'E')
    }
    return {}
}

export const getType = (meterPointsData = []) => {
    if (!meterPointsData || !Array.isArray(meterPointsData) || meterPointsData.length < 1 || !meterPointsData[0].purpose) {
        return null;
    }
    if (meterPointsData[0].purpose === 'Gas') {
        return 'G';
    } else if (meterPointsData[0].purpose === 'Electricity' || meterPointsData[0].purpose === 'Power') {
        return 'E';
    }
    return null;
}

export const pad = (n, width, z) => {
    z = z || '0';
    n = n + '';
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}

export const validateMeterPoints = meterPoints => (
    meterPoints.filter(x => (
        x.status === 'Live' &&
        x.energisationStatus === 'E' &&
        (x.purpose === 'Power' || x.purpose === 'Electricity') &&
        x.supplyEndDate === null &&
        x.registers &&
        Array.isArray(x.registers) &&
        x.registers.length &&
        x.registers.filter(y => (
            y.settlementType === 'S' && y.effectiveTo === null && y.meter && y.meter.type === 'N'
        )).length
    )).length
);

export const isValidEmail = userName => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,63}$/i.test(userName);

const filterActiveRegisters = (registers) => {
    const currentDate = new Date();
    return registers.filter(register => !register.effectiveTo || new Date(register.effectiveTo) >= currentDate);
};

export const filterMeterPointsByActiveRegisters = (meterPoint) => {
    return meterPoint.reduce((acc, curr) => {
        acc.push({
            ...curr,
            registers: filterActiveRegisters(curr.registers),
        })

        return acc;
    }, [])
};

export const getUniqueMeterPoints = (estate) => {
    let uniqueMeterPoints = new Map();
    estate.forEach(mp => {
        if (!uniqueMeterPoints.has(mp.id)) uniqueMeterPoints.set(mp.id, mp)
        else {
            if (uniqueMeterPoints.get(mp.id).endDate && uniqueMeterPoints.get(mp.id).endDate !== null && uniqueMeterPoints.get(mp.id).endDate < mp.endDate) {
                uniqueMeterPoints.set(mp.id, mp);
            }
        }
    });
    return Array.from(uniqueMeterPoints.values()).filter(mp => mp);
}

export const ReportActions = {
    Approve: "approve",
    Cancel: "cancel",
};

export const isDateOlderThanDays = (date, days) => {
    const currentDate = moment().startOf('day');
    const targetDate = moment(date).startOf('day');
    return targetDate.isBefore(currentDate.subtract(days, 'days'));
};
export const checkPathForTrue = (data, path) => {
    const parts = path.split('.');
    let current = data;
    for (let i = 0; i < parts.length; i++) {
        const part = parts[i];
        if (part === '#') {
            const rest = parts.slice(i + 1).join('.');
            if (!Array.isArray(current)) return false;
            return current.some((item) => checkPathForTrue(item, rest));
        } else if (/^\d+$/.test(part)) {
            if (!Array.isArray(current)) return false;
            current = current[parseInt(part, 10)];
        } else {
            if (current == null) return false;
            current = current[part];
        }
    }
    return current === true;
};


// Consul values may arrive as booleans or as "true"/"false" strings
export const isConsulFlagEnabled = (flag) => {
  const consul = window.config && window.config.consul;
  const value = consul && consul[flag];
  return value === true || value === "true";
};

export const isFeatureEnabled = (feature) => {
    let features = {};
    try {
        //Feature should always be function that returns boolean
        features = require("../" + window.config.consul.CLIENT + "/features/index.js").default;
    } catch (error) {
        // Fallback to an empty object if the file cannot be imported
        features = {};
    }
    return features[feature] ? features[feature]() : false;
}

export const isSSPClient = () => {
    const client = (window && window.config &&
        window.config.consul && window.config.consul.CLIENT) || '';

    return client.toLowerCase().includes('-ssp');
};

export const normalizeOrganizationValue = (value) =>
    String(value).trim().toLowerCase().replaceAll(/\s+/g, "");